import React, { useEffect } from 'react';
import { ChevronUpDownIcon } from '@heroicons/react/20/solid';
import { XCircleIcon } from '@heroicons/react/24/outline';
import { getLocations } from '../../api';

import useAsync from '../../hooks/useAsync';
import useModal from '../../hooks/useModal';

import { classNames } from '../helpers/functions';

const SelectLocations = ({
	key,
	locations,
	value,
	onChange,
	onClear,
	skip = [],
	placeholder,
	forceEmptyLabel = false, // sets default label if forced instead of placeholder
	isClearable = true,
	disableSearch,
	preventNew,
	modalName = 'selectLocation',
}) => {
	const { open, setOpen } = useModal(modalName);

	const { value: locationLocations, execute: refreshLocalLocations } = useAsync(
		getLocations,
		{ immediate: false },
	);

	useEffect(() => {
		if (typeof locations === 'undefined') {
			refreshLocalLocations();
		}
	}, []);

	const finalLocations = locationLocations || locations;

	const selectedLocation = value
		? finalLocations?.rows?.find((o) => o.id === value)
		: null;

	const locs = [];

	if (selectedLocation) {
		locs.push(selectedLocation?.name);

		const getParent = (o) => {
			if (o.parent_id) {
				const parent = finalLocations?.rows?.find((l) => l.id === o.parent_id);
				if (parent) {
					locs.push(parent.name);

					if (parent?.parent_id) {
						getParent(parent);
					}
				}
			}
		};

		getParent(selectedLocation);
	}

	return (
		<>
			<div
				key={key}
				className="relative mt-1 cursor-pointer"
				onClick={() =>
					setOpen({
						locations: finalLocations,
						onSelect: (selected) => onChange(selected?.id, selected),
						selected: value,
						skip,
						disableSearch,
						preventNew,
					})
				}
			>
				<div
					className={classNames(
						'flex flex-wrap truncate overflow-hidden items-center pointer-events-none w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm',
						value ? ' text-gray-900' : ' text-gray-400',
					)}
				>
					{locs?.length
						? locs?.map((location, i) => (
								<div
									className={classNames(
										'mr-1',
										i === 0 ? 'text-gray-800' : 'text-gray-400 text-xs',
									)}
								>
									{i === 0 ? `${location} ` : ` / ${location}`}
								</div>
							))
						: forceEmptyLabel || placeholder || 'Select a location'}
				</div>
				<div className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
					{value && isClearable ? (
						<XCircleIcon
							className="h-5 w-5 text-gray-900"
							aria-hidden="true"
							onClick={(e) => {
								e.stopPropagation();
								onChange(null);
							}}
						/>
					) : (
						<ChevronUpDownIcon
							className="h-5 w-5 text-gray-400"
							aria-hidden="true"
						/>
					)}
				</div>
			</div>
		</>
	);
};

export default SelectLocations;
